export enum TemplateAccessLevel {
    PUBLIC = 'PUBLIC',
    PRIVATE = 'PRIVATE',
    ORGANISATION = 'ORGANISATION'
}
